import React, { useState, useEffect } from "react";
import {
onAuthStateChanged,
signOut,
sendEmailVerification,
updateProfile,
updatePassword,
User,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../hooks/firebase";

const UserNavigation: React.FC = () => {
const [user, setUser] = useState<User | null>(null);
const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
const [toast, setToast] = useState<string>("");
const navigate = useNavigate();

const profileModalRef = React.useRef<HTMLDialogElement | null>(null);
const logoutModalRef = React.useRef<HTMLDialogElement | null>(null);
const emailVerificationModalRef = React.useRef<HTMLDialogElement | null>(null);

const [newName, setNewName] = useState<string>("");
const [newPassword, setNewPassword] = useState<string>("");

useEffect(() => {
const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
setUser(currentUser);
});
return () => unsubscribe();
}, []);

const sendToast = (content: string, timer = 3000) => {
setToast(content);
setTimeout(() => setToast(""), timer);
};

const handleLogout = async () => {
try {
await signOut(auth);
logoutModalRef?.current?.close();
navigate("/login");
} catch (error) {
console.error("Logout failed:", error);
sendToast((error as Error).message);
}
};

const handleEmailVerification = async () => {
if (user) {
try {
await sendEmailVerification(user);
emailVerificationModalRef?.current?.close();
sendToast("Verification email sent! Please check your inbox.");
} catch (error) {
console.error("Email verification failed:", error);
sendToast((error as Error).message);
}
}
};

const handleProfileUpdate = async () => {
try {
if (user && newName) {
await updateProfile(user, { displayName: newName });
sendToast("Name updated successfully!");
}
if (user && newPassword) {
await updatePassword(user, newPassword);
sendToast("Password updated successfully!");
}
profileModalRef?.current?.close();
} catch (error: any) {
sendToast(`Profile update failed: ${error.message}`);
}
};

const closeMenu = () => {
setIsMenuOpen(false);
};

if (!user) {
return (
<div>
<button
onClick={() => navigate("/login")}
style={{ padding: "0.5rem 1rem", fontSize: "1rem" }}
>
Sign in
</button>
</div>
);
}

return (
<div style={{ position: "relative", padding: "1rem" }}>
<div>
<button
onClick={() => setIsMenuOpen(!isMenuOpen)}
style={{
background: "#eee",
padding: "0.5rem 1rem",
fontSize: "1rem",
cursor: "pointer",
}}
aria-expanded={isMenuOpen}
>
{user.displayName || "User"} ({user.email})
</button>
{isMenuOpen && (
<div
style={{
position: "absolute",
top: "2.5rem",
left: "0",
background: "#fff",
border: "1px solid #ccc",
boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
padding: "1rem",
zIndex: 100,
}}
>
<p>Hi, {user.displayName || "User"}</p>
<button
onClick={() => {
profileModalRef.current?.showModal();
closeMenu();
}}
style={{ display: "block", marginBottom: "1rem", padding: "0.5rem 1rem" }}
>
Manage Your Profile
</button>
<button
onClick={() => {
logoutModalRef.current?.showModal();
closeMenu();
}}
style={{ display: "block", padding: "0.5rem 1rem" }}
>
Logout
</button>
</div>
)}
</div>
{user.emailVerified === false && (
<div>
<button
onClick={() => emailVerificationModalRef.current?.showModal()}
style={{ marginTop: "1rem" }}
>
Verify Your Email
</button>
</div>
)}
<dialog ref={logoutModalRef} aria-label="Logout Confirmation" aria-modal="true">
<button onClick={() => logoutModalRef.current?.close()} style={buttonStyle}>
Close popup
</button>
<h3>Are you sure you want to log out?</h3>
<p>you can log-back in to the site by using your google account, email/password and/or magic link?</p>
<p>google account and magic link are the secure methods to sign-in</p>
<p>if your email is not verified, the account will be deleted</p>
<button onClick={() => logoutModalRef.current?.close()} style={buttonStyle}>
Cancel
</button>
<button onClick={handleLogout} style={buttonStyle}>
OK
</button>
</dialog>
<dialog ref={profileModalRef} aria-label="Manage your profile" aria-modal="true">
<button onClick={() => profileModalRef.current?.close()} style={buttonStyle}>
Close popup
</button>
<h3>Edit Profile</h3>
<p>Manage your profile to make it truely yours</p>
<p>for complete modification of your profile, please go to <a href="https://accounts.techassistantforblind.com/">Your Accounts</a></p>
<input
type="text"
placeholder="New Name"
value={newName}
onChange={(e) => setNewName(e.target.value)}
style={{ display: "block", margin: "1rem 0", padding: "0.5rem" }}
/>
<input
type="password"
placeholder="New Password"
value={newPassword}
onChange={(e) => setNewPassword(e.target.value)}
style={{ display: "block", margin: "1rem 0", padding: "0.5rem" }}
/>
<button onClick={handleProfileUpdate} style={buttonStyle}>
Save Changes
</button>
<button onClick={() => profileModalRef.current?.close()} style={buttonStyle}>
Cancel
</button>
</dialog>
<dialog ref={emailVerificationModalRef} aria-label="Verify your email" aria-modal="true">
<button onClick={() => emailVerificationModalRef.current?.close()} style={buttonStyle}>
Close popup
</button>
<h3>Please verify your email.</h3>
<p>Verify your email to retain your account across multiple sign-ins and get exclusive content consume limits</p>
<p>We'll send you an email containing the verification link, please click the link to verify your account</p>
<button onClick={handleEmailVerification} style={buttonStyle}>
Send Verification Email
</button>
<button onClick={() => emailVerificationModalRef.current?.close()} style={buttonStyle}>
OK
</button>
</dialog>
{toast && <p role="alert">{toast}</p>}
</div>
);
};

const buttonStyle: React.CSSProperties = {
margin: "0.5rem",
padding: "0.5rem 1rem",
cursor: "pointer",
};

export default UserNavigation;
